import styled from "@emotion/styled";
import PermissionTableHeaderRow from "./header-row";
import {
  CheckContainer,
  IndexContainer,
  ItemContainer,
  RowContainer,
  RowsContainer,
  TableRowContainer,
} from "./index.styles";
import UI from "@mile-meeting/mile-ui";
import { DATA } from "./data";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;

  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 20px 0 0 20px;

  box-sizing: border-box;
`;

const PermissionTable = () => {
  const getIconName = (value: boolean | undefined) => {
    switch (value) {
      case true:
        return "checkCircle";
      case undefined:
        return "minusCircle";
      default:
        return "removeCircle";
    }
  };

  const getColor = (value: boolean | undefined) => {
    switch (value) {
      case true:
        return "var(--alias-color-primary-normal)";
      case undefined:
        return "var(--alias-color-status-cautionary)";
      default:
        return "var(--alias-color-label-alternative)";
    }
  };

  return (
    <Container className="table">
      <PermissionTableHeaderRow />
      <TableRowContainer>
        {DATA.map((item, index) => (
          <ItemContainer key={index}>
            <IndexContainer>
              <UI.Typography type="body01 normal" fontStyle="bold" style={{ whiteSpace: "pre-line" }}>
                {item.section}
              </UI.Typography>
            </IndexContainer>
            <RowsContainer>
              {item.pages.map((page, index) => (
                <RowContainer key={index}>
                  <div className="pageName">
                    <UI.Typography
                      type="label01"
                      fontStyle="medium"
                      color="var(--alias-color-label-normal)"
                      style={{ whiteSpace: "pre-line" }}
                    >
                      {page.title}
                    </UI.Typography>
                  </div>
                  <div className="checkContainer">
                    <CheckContainer>
                      <UI.Icon size={20} name={getIconName(page.owner)} color={getColor(page.owner)} />
                    </CheckContainer>
                    <CheckContainer>
                      <UI.Icon size={20} name={getIconName(page.superAdmin)} color={getColor(page.superAdmin)} />
                    </CheckContainer>
                    <CheckContainer>
                      <UI.Icon size={20} name={getIconName(page.policyAdmin)} color={getColor(page.policyAdmin)} />
                    </CheckContainer>
                    <CheckContainer>
                      <UI.Icon size={20} name={getIconName(page.securityAdmin)} color={getColor(page.securityAdmin)} />
                    </CheckContainer>
                    <CheckContainer>
                      <UI.Icon size={20} name={getIconName(page.staff)} color={getColor(page.staff)} />
                    </CheckContainer>
                  </div>
                </RowContainer>
              ))}
            </RowsContainer>
          </ItemContainer>
        ))}
      </TableRowContainer>
    </Container>
  );
};

export default PermissionTable;
